import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";
import styles from "./ARButton.module.scss";

const ARButton = ({ product }) => {
  const { Model, ARLink } = product;

  const handleClick = () => {
    console.log(product)
    GAevent("Guest-User", "click", `Buy Now Button - ${Model}`);
  };

  return (
    <>
      {ARLink && (
        <button className={styles.btn}>
          <a className={`ARButton - ${Model}`} href={ARLink} rel="noreferrer" target="_blank" onClick={handleClick}>
            Product AR
          </a>
        </button>
      )}
    </>
  );
};

export { ARButton };
